import MandateORM from "@/store/orm-axios/models/Mandate";
import { meetingMinutesNames } from "@/constants/meeting.js";

export default {
  methods: {
    getAllLastEvents(meetingMinutes, dateOfComparison, options) {
      const { forOneMandateId } = options;
      const { incluedsDateOfComparison } = options;

      // get all minute events (regarding presence .. e.g. participant-arrived, correspondence..) before dateOfComparison
      const neededEventsNames = [
        meetingMinutesNames.correspondence,
        meetingMinutesNames.participant_arrived,
        meetingMinutesNames.contact_arrived,
        meetingMinutesNames.mandate_added,
        meetingMinutesNames.mandate_moved,
        meetingMinutesNames.mandate_left,
        meetingMinutesNames.contact_left,
        meetingMinutesNames.participant_left,
      ];
      return meetingMinutes.filter(minute => {
        const minuteDateNumber = new Date(minute.date).getTime();
        const dateOfComparisonNumber = new Date(dateOfComparison).getTime();
        const operator = incluedsDateOfComparison ? "<=" : "<";
        return (
          neededEventsNames.includes(minute.event) &&
          (minute.date
            ? eval(`${minuteDateNumber} ${operator} ${dateOfComparisonNumber}`)
            : true) &&
          (forOneMandateId ? minute.mandate_id == forOneMandateId : true)
        );
      });
    },
    getLastEvents(meetingMinutes, dateOfComparison) {
      const neededEvents = this.getAllLastEvents(meetingMinutes, dateOfComparison, {
        incluedsDateOfComparison: true,
      });

      // group by mandate_id and get last event for each
      let groupedNeededEvents = this.$_.groupBy(neededEvents, item => {
        return item.mandate_id;
      });
      let lastEvents = [];
      for (const groupOfEvents of Object.values(groupedNeededEvents)) {
        const lastEventOfGroup = this.$_.max(groupOfEvents, item => {
          return item.date ? new Date(item.date).getTime() : -Infinity;
        });
        lastEvents.push(lastEventOfGroup);
      }

      return lastEvents;
    },
    getLastEvent(meetingMinutes, dateOfComparison, mandateId) {
      const neededEvents = this.getAllLastEvents(meetingMinutes, dateOfComparison, {
        forOneMandateId: mandateId,
      });

      return this.$_.max(neededEvents, item => {
        return item.date ? new Date(item.date).getTime() : -Infinity;
      });
    },
    getMeetingStartInfo(meeting, meetingStart) {
      let meetingStartInfo = {
        Present: [],
        PresentDistance: [],
        Represented: [],
        Correspondence: [],
        InvalidCorrespondence: [],
        Absents: [],
        tantiemesDetails: {
          present: 0,
          present_distance: 0,
          represented: 0,
          correspondence: 0,
          invalid_correspondence: 0,
          absents: 0,
        },
      };

      const lastEvents = this.getLastEvents(meeting.minutes, meetingStart.date);

      const allMandates = MandateORM.getters("getMandatesByMeeting")(meeting.id);
      for (const mandate of allMandates) {
        const lastEvent = lastEvents.find(e => {
          return e.mandate_id == mandate.id;
        });

        if (this.checkAbsents(lastEvent)) {
          meetingStartInfo.Absents.push(mandate);
          meetingStartInfo.tantiemesDetails.absents += this.getUsedMandateTantiemesChargeGenerale(
            mandate.id
          );
        } else if (this.checkPresent(lastEvent)) {
          meetingStartInfo.Present.push(mandate);
          meetingStartInfo.tantiemesDetails.present += this.getUsedMandateTantiemesChargeGenerale(
            mandate.id
          );
        } else if (this.checkPresentDistance(lastEvent)) {
          meetingStartInfo.PresentDistance.push(mandate);
          meetingStartInfo.tantiemesDetails.present_distance += this.getUsedMandateTantiemesChargeGenerale(
            mandate.id
          );
        } else if (this.checkRepresented(lastEvent)) {
          meetingStartInfo.Represented.push(mandate);
          meetingStartInfo.tantiemesDetails.represented += this.getUsedMandateTantiemesChargeGenerale(
            mandate.id
          );
        } else if (this.checkCorrespondence(lastEvent)) {
          meetingStartInfo.Correspondence.push(mandate);
          meetingStartInfo.tantiemesDetails.correspondence += this.getUsedMandateTantiemesChargeGenerale(
            mandate.id
          );
        } else if (this.checkInvalidCorrespondence(lastEvent)) {
          meetingStartInfo.InvalidCorrespondence.push(mandate);
          meetingStartInfo.tantiemesDetails.invalid_correspondence += this.getUsedMandateTantiemesChargeGenerale(
            mandate.id
          );
        }
      }

      return meetingStartInfo;
    },
    checkAbsents(event) {
      return !event || event.new_presence_status == this.mandatePresenceStatuses.not_present;
    },
    checkPresent(event) {
      return (
        event.new_presence_status == this.mandatePresenceStatuses.physical ||
        event.new_presence_status == this.mandatePresenceStatuses.physical_tab
      );
    },
    checkPresentDistance(event) {
      return (
        event.new_presence_status == this.mandatePresenceStatuses.video ||
        event.new_presence_status == this.mandatePresenceStatuses.phone
      );
    },
    checkRepresented(event) {
      return (
        event.new_presence_status == this.mandatePresenceStatuses.pouvoir ||
        event.new_presence_status == this.mandatePresenceStatuses.pouvoir_by_video
      );
    },
    checkCorrespondence(event) {
      return event.new_presence_status == this.mandatePresenceStatuses.correspondence;
    },
    checkInvalidCorrespondence(event) {
      return event.new_presence_status == this.mandatePresenceStatuses.invalid_correspondence;
    },

    getPresenceChangesInfo(meeting, event) {
      const lastEvents = this.getLastEvents(meeting.minutes, event.date);

      const allMandates = MandateORM.getters("getMandatesByMeeting")(meeting.id);
      const presentMandates = [];
      const representedParticipantsThatLeft = [];
      for (const mandate of allMandates) {
        const lastEvent = lastEvents.find(e => {
          return e.mandate_id == mandate.id;
        });

        if (
          lastEvent &&
          lastEvent.new_presence_status != this.mandatePresenceStatuses.not_present &&
          lastEvent.new_presence_status != this.mandatePresenceStatuses.invalid_correspondence &&
          lastEvent.new_presence_status !=
            this.mandatePresenceStatuses.pouvoir_by_video_not_present_yet
        ) {
          presentMandates.push(mandate);
        } else if (lastEvent && lastEvent.event == meetingMinutesNames.participant_left) {
          // NOTE: For participant-left -> look for bo if was represented in a mandate-moved event before he left and get the presence from the representant
          const lastEventDateTime = new Date(lastEvent.date).getTime();
          const mandateMoved = meeting.minutes.find(e => {
            const eventDateTime = new Date(e.date).getTime();
            return (
              e.event == meetingMinutesNames.mandate_moved &&
              e.building_owner_id == mandate.building_owner_id &&
              (e.date ? eval(eventDateTime <= lastEventDateTime) : false)
            );
          });
          if (mandateMoved) representedParticipantsThatLeft.push(mandate);
        }
      }

      const presentAndRepresentedMandatesThatLeft = presentMandates.concat(
        representedParticipantsThatLeft
      );

      return {
        totalPresentMandates: presentAndRepresentedMandatesThatLeft.length,
        totalPresentTantiemes: this.getMandatesTantiemesChargeGenerale(
          presentAndRepresentedMandatesThatLeft,
          true
        ),
        totalMandatesTantiemes: this.getMandatesTantiemesChargeGenerale(allMandates, true),
      };
    },

    getLastPresenceStatus(meetingMinutes, event) {
      const lastEvent = this.getLastEvent(meetingMinutes, event.date, event.mandate_id);

      return lastEvent ? lastEvent.new_presence_status : null;
    },
  },
};
